import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';

const TONE_CLASS = {
	success: { border: 'border-success', icon: 'text-success' },
	danger: { border: 'border-danger', icon: 'text-danger' },
	info: { border: 'border-info', icon: 'text-info' },
	warning: { border: 'border-warning', icon: 'text-warning' },
};

const OrderModalCollaborationNotice = ({ message, tone = 'info', icon = 'circle-info', isSyncing = false }) => {
	if (!message && !isSyncing) return null;

	const classes = TONE_CLASS[tone] ?? TONE_CLASS.info;

	return (
		<div
			className={`py-2 px-2 mb-2 border-start border-3 ${classes.border} bg-100 rounded-1 fs-10 text-600`}
			role='status'
			aria-live='polite'
		>
			<div className='d-flex align-items-center gap-2'>
				{isSyncing && !message ? (
					<Spinner animation='border' size='sm' className={classes.icon} role='status' />
				) : (
					<FontAwesomeIcon icon={icon} className={`${classes.icon} flex-shrink-0`} />
				)}
				<span className='fw-semibold'>{message || '正在同步他人操作…'}</span>
			</div>
			{message ? (
				<div className='text-500 mt-1 ps-4'>本页操作已锁定，请关闭弹窗后从待办列表查看最新状态。</div>
			) : null}
		</div>
	);
};

OrderModalCollaborationNotice.propTypes = {
	message: PropTypes.string,
	tone: PropTypes.oneOf(['success', 'danger', 'info', 'warning']),
	icon: PropTypes.string,
	isSyncing: PropTypes.bool,
};

export default OrderModalCollaborationNotice;
